import { modalWindowConstants } from './../../actions/modalWindow/actionTypes';
import { produce } from 'immer';
import { AnyAction } from 'redux';
const initialState = {
    isOpen: false,
    fileUrl: null as string | null,
    fileId: null as number | null,
    fileMimetype: null as string | null,
    fileBlob: null as Blob | null,
};

export function modalWindowReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case modalWindowConstants.OPEN_MODAL_WINDOW:
            return produce(state, (draft) => {
                draft.isOpen = true;
            });
        case modalWindowConstants.CLOSE_MODAL_WINDOW:
            return produce(state, (draft) => {
                draft.isOpen = false;
                draft.fileUrl = null;
            });
        case modalWindowConstants.SET_FILE_MIMETYPE:
            return produce(state, (draft) => {
                draft.fileMimetype = action.payload.fileMimetype;
            });
        case modalWindowConstants.SET_FILE_ID:
            return produce(state, (draft) => {
                draft.fileId = action.payload.fileId;
            });
        case modalWindowConstants.SET_FILE_URL:
            return produce(state, (draft) => {
                draft.fileUrl = action.payload.fileUrl;
            });
        case modalWindowConstants.SET_FILE_BLOB:
            return produce(state, (draft) => {
                draft.fileBlob = action.payload.fileBlob;
            });
        default:
            return state;
    }
}
